import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getIssueSeverity } from 'pages/Desk/issues/shared';
import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

type SeverityLozengeProps = Readonly<{
    severity: number;
}>;

function SeverityLozenge({ severity }: SeverityLozengeProps) {
    const { label, icon, backgroundColor } = getIssueSeverity(severity);
    const upperLabel = label.toUpperCase();

    return (
        <Lozenge color={tokens.text.onColor} backgroundColor={backgroundColor}>
            <FontAwesomeIcon icon={icon} />
            {upperLabel}
        </Lozenge>
    );
}

const memoSeverityLozenge = memo(SeverityLozenge);
export { memoSeverityLozenge as SeverityLozenge };
